//ANGULAR
import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Subject } from 'rxjs';
//INTERFACES
import { MessageBox } from '../interfaces/message-box';

@Injectable()
export class MessageBoxService {

    index:number = 0;
    messageBoxList: MessageBox[] = [];

    constructor() {}
    //OPRET STRENG DER KAN SUBSCRIBES TIL FRA ANDRE KOMPONENTER
    private messageTextSource = new BehaviorSubject<MessageBox[]>(null);
    messageText$ = this.messageTextSource.asObservable();


    //OPRET MESSAGE BOKS MED FEJL
    createMessageboxError(message: string) {
         var messageBox = {
            index: this.index +1,
            message: message,
            timeout: 5000,
            class: { 'alert-success': false, 'alert-danger': true, 'alert-warning': false, 'alert-info': false }
        }
        this.messageBoxList.splice(0, 0, messageBox);
        this.messageTextSource.next(this.messageBoxList);
        
        setTimeout(()=> {
            this.messageBoxList.splice(this.messageBoxList.indexOf(messageBox) ,1);
            this.messageTextSource.next(this.messageBoxList);
         }, messageBox.timeout);
    }
    //OPRET MESSAGE BOKS MED ADVARSEL
    createMessageboxWarning(message: string) {
        var messageBox = {
            index: this.index +1,
            message: message,
            timeout: 5000,
            class: { 'alert-success': false, 'alert-danger': false, 'alert-warning': true, 'alert-info': false }
        }
        this.messageBoxList.splice(0, 0, messageBox);
        this.messageTextSource.next(this.messageBoxList);
        setTimeout(()=> {
            this.messageBoxList.splice(this.messageBoxList.indexOf(messageBox) ,1);
            this.messageTextSource.next(this.messageBoxList);
         }, messageBox.timeout);
    }
    //OPRET MESSAGE BOKS MED SUCCESS
    createMessageboxSuccess(message: string) {
        var messageBox = {
            index: this.index +1,
            message: message,
            timeout: 5000,
            class: { 'alert-success': true, 'alert-danger': false, 'alert-warning': false, 'alert-info': false }
        }
        this.messageBoxList.splice(0, 0, messageBox);
        this.messageTextSource.next(this.messageBoxList);
        setTimeout(()=> {
            this.messageBoxList.splice(this.messageBoxList.indexOf(messageBox) ,1);
            this.messageTextSource.next(this.messageBoxList);
         }, messageBox.timeout);
    }
}
export interface Result {
    message?: string 
}


// //ANGULAR
// import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs/BehaviorSubject';
// //INTERFACES
// import { MessageBox } from '../interfaces/message-box';

// @Injectable()
// export class MessageBoxService {

//     messageBox: MessageBox;

//     constructor() {
//         this.messageBox = {
//             message: '',
//             timeout: 0,
//             class: { 'alert-success': false, 'alert-danger': false, 'alert-warning': true, 'alert-info': false }
//         };
//     }
//     //OPRET STRENG DER KAN SUBSCRIBES TIL FRA ANDRE KOMPONENTER
//     private messageTextSource = new BehaviorSubject<MessageBox>(null);
//     messageText$ = this.messageTextSource.asObservable();

//     //OPRET MESSAGE BOKS MED FEJL
//     createMessageboxError(message: string) {
//         this.messageBox.message = message;
//         this.messageBox.timeout = 10000;
//         this.messageBox.class = { 'alert-success': false, 'alert-danger': true, 'alert-warning': false, 'alert-info': false };
//         this.messageTextSource.next(this.messageBox);
//     }
//     //OPRET MESSAGE BOKS MED ADVARSEL
//     createMessageboxWarning(message: string) {
//         this.messageBox.message = message;
//         this.messageBox.timeout = 5000;
//         this.messageBox.class = { 'alert-success': false, 'alert-danger': false, 'alert-warning': true, 'alert-info': false };
//         this.messageTextSource.next(this.messageBox);
//     }
//     //OPRET MESSAGE BOKS MED SUCCESS
//     createMessageboxSuccess(message: string) {
//         this.messageBox.message = message;
//         this.messageBox.timeout = 5000;
//         this.messageBox.class = { 'alert-success': true, 'alert-danger': false, 'alert-warning': false, 'alert-info': false };
//         this.messageTextSource.next(this.messageBox);
//     }
// }
// export interface Result {
//     message?: string 
// }